import { Col, Row } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Form from '@/src/shared/components/Form';
import { space } from '@/styles';

import { updateSearchCriteria } from '../../redux/amicusReducer';
import SearchFilters from './AmicusSearchFilters';
import SearchResults from './AmicusSearchResults';
import TagTile from './TagTile';

const FIELD_NAMES = {
  CASE_NAME: 'CaseNames',
  STATE: 'States',
  ISSUE: 'Issues',
  STATUS: 'Statuses',
};

function AmicusSearch(props) {
  const { form } = props;

  const [filterExpanded, setFilterExpanded] = useState(true);

  const dispatch = useDispatch();

  const {
    fieldOptionsData: { options },
    searchCriteria,
  } = useSelector(state => state.amicus);
  const { statuses, states, caseNames, issues } = options;

  const searchKeys = Object.keys(searchCriteria);
  const filterTags = [];

  const handleCriteriaChange = (name, value) => {
    // eslint-disable-next-line react/destructuring-assignment
    dispatch(updateSearchCriteria(name, value));
  };

  const tagClose = (e, value, input) => {
    e.preventDefault();
    const storedValue = form.getFieldValue(input);
    const fieldValues = searchCriteria[input];
    const updatedFieldValues = fieldValues.filter(v => v !== value);
    handleCriteriaChange(input, updatedFieldValues);

    if (Array.isArray(storedValue)) {
      form.setFieldsValue({ [input]: updatedFieldValues });
    } else {
      form.setFieldsValue({ [input]: [] });
    }
  };

  const handleFiltersCollapseChange = activeTabs => {
    setFilterExpanded(activeTabs.includes('1'));
  };

  searchKeys.forEach(k => {
    const fieldValue = searchCriteria[k];

    if (!Array.isArray(fieldValue)) return;
    if (k === FIELD_NAMES['CASE_NAME']) {
      fieldValue.forEach(v => {
        const selectedCase = caseNames.find(c => Number(c.Value) === Number(v));
        if (selectedCase) {
          const formattedState = {
            value: v,
            children: selectedCase.Text,
            input: k,
          };
          filterTags.push(formattedState);
        }
      });
    }

    if (k === FIELD_NAMES['STATE']) {
      fieldValue.forEach(v => {
        const selectedState = states.find(s => s.StateCode === v);
        if (selectedState) {
          const formattedState = {
            value: v,
            children: selectedState.StateDescription,
            input: k,
          };
          filterTags.push(formattedState);
        }
      });
    }

    if (k === FIELD_NAMES['ISSUE']) {
      fieldValue.forEach(v => {
        const selectedIssue = issues.find(i => i.IssueId === v);
        if (selectedIssue) {
          const formattedIssue = {
            value: v,
            children: selectedIssue.IssueName,
            input: k,
          };
          filterTags.push(formattedIssue);
        }
      });
    }

    if (k === FIELD_NAMES['STATUS']) {
      fieldValue.forEach(v => {
        const selectedStatus = statuses.find(i => i.StatusCode === v);
        if (selectedStatus) {
          const formattedIssue = {
            value: v,
            children: selectedStatus.StatusDescription,
            input: k,
          };
          filterTags.push(formattedIssue);
        }
      });
    }
  });

  return (
    <Row type="flex" gutter={{ xs: 24, md: 32 }}>
      <Col xs={24} lg={8}>
        <SearchFilters form={form} handleFiltersCollapseChange={handleFiltersCollapseChange} />
      </Col>
      <Col xs={24} lg={16}>
        <div css={space.m.b16}>
          {!filterExpanded &&
            filterTags.map(tag => <TagTile key={tag.value} tag={tag} tagClose={tagClose} />)}
        </div>
        <SearchResults />
      </Col>
    </Row>
  );
}

AmicusSearch.propTypes = {};

export default Form.create({ name: 'AmicusSearchForm' })(AmicusSearch);
